import React from "react";
import groxLogo from "./assets/groxlogo.png";
import heroPhone from "./assets/hero-phone.png";
import heroCart from "./assets/hero-cart.png";
import catSignature from "./assets/cat-signature.png";
import catClean from "./assets/cat-clean.png";
import catStaples from "./assets/cat-staples.png";
import catDairy from "./assets/cat-dairy.png";
import catMeat from "./assets/cat-meat.png";
import catSnacks from "./assets/cat-snacks.png";
import catCleaning from "./assets/cat-cleaning.png";
import catHygiene from "./assets/cat-hygiene.png";
import sigBadge from "./assets/signature-badge.png";
import sigSplash from "./assets/sig-splash.png";
import iconSigFresh from "./assets/icon-sig-fresh.png";
import iconDelivery from "./assets/icon-delivery.png";
import iconVariety from "./assets/icon-variety.png";
import iconTrusted from "./assets/icon-trusted.png";
import flavorsFood from "./assets/flavors-food.jpg";
import ctaPhone1 from "./assets/cta-phone1.png";
import ctaPhone2 from "./assets/cta-phone2.png";
import ctaPhone3 from "./assets/cta-phone3.png";
import googlePlay from "./assets/google-play.png";
import appStore from "./assets/app-store.png";
import brush from "./assets/brush.png";
import flavorsLogo from "./assets/flavors-logo.png";
import { Link } from "react-router-dom";

const S = {
  page: { fontFamily: "PoppinsCustom, sans-serif", color: "#111", margin: 0, padding: 0, overflowX: "hidden" },

  /* ─ HEADER ─ */
  header: {
    background: "#E3EEE5",
    borderBottom: "1px solid #e8f0e0",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 80px",
    height: 85,
    position: "sticky",
    top: 0,
    zIndex: 100,
    position: "fixed",
    left: 0,
    width: "90%",
    zIndex: 1000,
    boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
  },
  headerLogo: { width: 100, display: "block" },
  headerNav: { display: "flex", alignItems: "center", gap: 32 },
  headerNavLink: {
    textDecoration: "none",
    color: "#333",
    fontWeight: 600,
    fontSize: 15,
    transition: "color 0.2s",
  },
  headerRight: { display: "flex", alignItems: "center", gap: 18 },
  socialLink: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 38,
    height: 38,
    borderRadius: "50%",
    background: "#f0f5ec",
    color: "#333",
    textDecoration: "none",
    transition: "background 0.2s, color 0.2s",
  },
  downloadBtn: {
    background: "#46A084",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    padding: "9px 22px",
    fontWeight: 700,
    fontSize: 14,
    cursor: "pointer",
    marginLeft: 6,
  },

  /* ─ HERO ─ */
  hero: { background: "#fff", display: "flex", alignItems: "center", justifyContent: "space-between", padding: "40px 80px", minHeight: "88vh", gap: 40 },
  heroLeft: { flex: "0 0 auto", maxWidth: 560 },
  groxLogo: { width: 120, marginBottom: 36 },
  heroHighlight: {
    display: "inline-block",
    fontWeight: 900,
    padding: "2px 10px",
    background: `url(${brush}) center/120% 490% no-repeat`,
    color: "#fff"
  },
  heroH1: { fontSize: 58, fontWeight: 900, lineHeight: 1.1, margin: 0, fontFamily: "MontserratCustom, sans-serif", },
  heroSub: { fontSize: 25, color: "#444", lineHeight: 1.65, margin: "0 0 32px", maxWidth: 600, fontFamily: "PoppinsCustom, sans-serif", },
  badgesRow: { display: "flex", gap: 16, marginBottom: 20 },
  storeBadge: { height: 48, cursor: "pointer" },
  servingPill: { display: "inline-block", border: "1.5px solid #3BB54A", borderRadius: 20, padding: "5px 18px", fontSize: 14, color: "#333" },
  heroRight: { position: "relative", flex: "0 0 auto" },
  heroCartImg: { width: 460, objectFit: "contain", display: "block" },
  heroPhoneImg: { position: "absolute", bottom: 0, left: -90, width: 185 },
  catSection: {
    background: "#e5eede",
    padding: "70px 80px"
  },

  catH2: {
    fontSize: 44,
    fontWeight: 900,
    lineHeight: 1.15,
    margin: "0 0 8px"
  },

  catSub: {
    fontSize: 18,
    color: "#444",
    margin: "0 0 40px"
  },

  catGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(5, 180px)",
    gap: 52,
  },
  catCard: {
    height: 210,
    borderRadius: 22,
    overflow: "hidden",
    background: "#fff",
    cursor: "pointer",
    boxShadow: "5px 5px 0px rgba(0,0,0,0.15)",
    transition: "all 0.25s ease"
  },

  catImg: {
    width: "100%",
    height: "100%",
    objectFit: "fill",
    display: "block"
  },
  browseCard: {
    borderRadius: 18,
    background: "#b8dbb8",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 2,
    cursor: "pointer",
    padding: 20,
    boxShadow: "6px 3px 0px rgba(0,0,0,0.25)",
    transition: "all 0.2s ease"
  },
  browsePre: { fontSize: 17, color: "#333", margin: 0 },
  browseNum: { fontSize: 44, fontWeight: 900, margin: 0, lineHeight: 1 },
  browseLabel: { fontSize: 17, color: "#333", margin: 0 },
  shopNowBtn: {
    marginTop: 14,
    background: "#fff",
    borderRadius: 10,
    padding: "11px 46px",
    fontWeight: 700,
    border: "none",
    outline: "none",
    fontSize: 14,
    letterSpacing: 1,
    cursor: "pointer",
    boxShadow: "6px 3px 0px rgba(0,0,0,0.25)",
    transition: "all 0.2s ease",
    fontFamily: "PoppinsCustom, sans-serif"
  },

  /* ─ SIGNATURE FRESH ─ */
  sigSection: {
    background: "#f6faf7",
    padding: "60px 80px 0",
    overflow: "visible",
    position: "relative"
  },
  sigTop: { display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 36 },
  sigLeft: { maxWidth: 560 },
  sigH2: { fontSize: 38, fontWeight: 900, margin: "0 0 6px" },
  sigH2Light: { fontWeight: 400, },
  sigH3: { fontSize: 26, fontWeight: 400, margin: "0 0 18px", color: "#222" },
  sigBody: { fontSize: 15, color: "#444", lineHeight: 1.9, maxWidth: 430, textAlign: "justify" },
  sigBadgeImg: {
    width: 255,
    flexShrink: 0,
    position: "relative",
    left: -60
  },
  sigCards: {
    position: "relative",
    height: 220,
    zIndex: 5
  },
  sigCard: {
    position: "absolute",
    width: 320,
    borderRadius: 22,
    padding: "12px 28px",
    boxShadow: "14px 16px 0 rgba(0,0,0,0.18)",
  },
  sigCardPink: { background: "#efe4dc" },
  sigCardCream: { background: "#f4ede4" },
  sigCardBlue: { background: "#dbe6ef" },

  sigCardTitle: {
    fontWeight: 800,
    fontSize: 18,
    marginBottom: 6
  },

  sigCardText: {
    fontSize: 14,
    color: "#555",
    lineHeight: 1.4,
    margin: 0
  },
  card1: {
    top: 0,
    left: 40,
    background: "#fceded",
  },

  card2: {
    top: 0,
    right: 220,
    background: "#F7F0E7"
  },

  card3: {
    top: 140,
    left: 360,
    background: "#EDF7EF"
  },

  card4: {
    top: 140,
    right: 5,
    background: "#E5F3F5"
  },

  sigSplashImg: {
    width: "120%",
    marginLeft: "-10%",
    height: "auto",
    objectFit: "contain",
    display: "block",
    zIndex: 50000
  },
  trustSection: {
    background: "#ffff",
    padding: "80px 60px",
    textAlign: "center"
  },

  trustH2: {
    fontSize: 28,
    letterSpacing: 2,
    fontWeight: 400,
    marginBottom: 80,
    textTransform: "uppercase"
  },

  trustH2Bold: { fontWeight: 900 },

  trustGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(4,1fr)",
    gap: 40,
    alignItems: "flex-start",
    marginTop: 40,
    marginBottom: 60
  },

  trustCard: {
    background: "#F6FAF7",
    borderRadius: 28,
    padding: "40px 12px 20px",
    position: "relative",
    height: 160,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  },

  iconCircle: {
    width: 90,
    height: 90,
    background: "transparent",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: -45,
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 2
  },

  trustIcon: {
    width: 126,
    height: 126,
    objectFit: "contain",
  },

  trustText: {
    fontSize: 18,
    lineHeight: 1.7,
    color: "#333",
    marginTop: 10,
    maxWidth: 220,
    textAlign: "center"
  },

  trustBanner: {
    display: "inline-block",
    background: "#46A084",
    color: "#fff",
    padding: "16px 50px",
    borderRadius: 10,
    fontSize: 20,
    fontWeight: 600
  },

  /* ─ FLAVORS ─ */
  flavorsSection: { display: "grid", gridTemplateColumns: "1fr 380px", minHeight: 500 },
  flavorsLeft: { position: "relative", overflow: "hidden" },
  flavorsImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
    transform: "rotate(180deg)"
  },
  flavorsOverlay: { position: "absolute", top: 0, left: 0, padding: "40px" },
  flavorsLogoImg: {
    width: "180px",
  },
  flavorsLogoText: { fontSize: 42, fontWeight: 900, fontStyle: "italic", color: "#1f9c72", fontFamily: "Georgia, serif", margin: "0 0 6px" },
  flavorsTagline: { fontSize: 22, fontWeight: 700, color: "#e07820", margin: "0 0 16px" },
  flavorsBody: { fontSize: 17, lineHeight: 1.7, color: "#111", maxWidth: 500, textAlign: "justify" },
  flavorsRight: {
    display: "grid",
    gridTemplateRows: "1fr 1fr 1fr",
    gap: "20px",
    height: "100%",
    padding: "0 20px"
  },
  flavorsFeature: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: "28px 30px",
    borderRadius: "4px",
    boxSizing: "border-box"
  },
  flavorsFeatureTeal: { background: "#E3EEE5" },
  flavorsFeatureGreen: { background: "#BBDEC1" },
  flavorsFeatureSkyTeal: { background: "#B1D3CB" },
  fFTitle: { fontWeight: 800, fontSize: 22, margin: "0 0 10px" },
  fFText: { fontSize: 19, color: "#444", lineHeight: 1.65, margin: 0 },

  /* ─ CTA ─ */
  ctaSection: { background: "#e5eede", display: "flex", alignItems: "center", padding: "60px 80px", gap: 60 },
  ctaLeft: { flex: "0 0 400px" },
  ctaH2: { fontSize: 34, fontWeight: 900, lineHeight: 1.2, margin: "0 0 16px" },
  ctaSub: { fontSize: 16, color: "#444", lineHeight: 1.7, margin: "0 0 26px", maxWidth: 370 },
  ctaList: { listStyle: "none", padding: 0, margin: "0 0 28px" },
  ctaItem: { display: "flex", alignItems: "center", gap: 10, fontWeight: 700, fontSize: 16, marginBottom: 10 },
  ctaCheck: { color: "#46A084", fontSize: 18, flexShrink: 0 },
  ctaBtn: { background: "#46A084", color: "#fff", border: "none", borderRadius: 10, padding: "14px 30px", fontSize: 16, fontWeight: 700, cursor: "pointer", marginBottom: 22, display: "block" },
  ctaRight: { flex: 1, display: "flex", justifyContent: "center", alignItems: "flex-end", gap: 12 },
  ctaPhone: { height: 360, objectFit: "contain", borderRadius: 28, boxShadow: "0 10px 36px rgba(0,0,0,0.15)" },
  ctaPhoneCenter: { height: 400, objectFit: "contain", borderRadius: 28, boxShadow: "0 12px 40px rgba(0,0,0,0.22)", zIndex: 1 },

  /* ─ FOOTER ─ */
  footer: {
    background: "#1c1c1c",
    color: "#ccc",
    padding: "60px 80px 0",
    fontFamily: "PoppinsCustom, sans-serif",
  },
  footerGrid: {
    display: "grid",
    gridTemplateColumns: "1.4fr 1fr 1fr 1.2fr",
    gap: 60,
    paddingBottom: 48,
    borderBottom: "1px solid #333",
  },
  footerBrand: {
    display: "flex",
    flexDirection: "column",
    gap: 14,
  },
  footerLogoImg: {
    width: 110,
    marginBottom: 6,
  },
  footerTagline: {
    color: "#ffffff",
    fontWeight: 700,
    fontSize: 14,
    margin: 0,
  },
  footerDesc: {
    fontSize: 13,
    color: "#999",
    lineHeight: 1.8,
    margin: 0,
    maxWidth: 280,
  },
  footerSocialRow: {
    display: "flex",
    gap: 14,
    marginTop: 10,
  },
  footerSocialIcon: {
    width: 40,
    height: 40,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    flexShrink: 0,
  },
  footerColTitle: {
    color: "#ffffff",
    fontWeight: 700,
    fontSize: 16,
    marginBottom: 20,
    marginTop: 0,
  },
  footerLinks: {
    listStyle: "none",
    padding: 0,
    margin: 0,
    display: "flex",
    flexDirection: "column",
    gap: 12,
  },
  footerLink: {
    color: "#aaa",
    textDecoration: "none",
    fontSize: 14,
    transition: "color 0.2s",
    cursor: "pointer",
  },
  footerContactLine: {
    fontSize: 14,
    color: "#aaa",
    margin: "0 0 10px",
  },
  footerContactIcons: {
    display: "flex",
    gap: 16,
    marginTop: 20,
  },
  footerContactIconCircle: {
    width: 44,
    height: 44,
    borderRadius: "50%",
    border: "2px solid #46A084",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    color: "#46A084",
    transition: "background 0.2s, color 0.2s",
  },
  footerBottom: {
    textAlign: "center",
    padding: "18px 0",
    fontSize: 13,
    color: "#fff",
  },
};

/* ── SVG Social Icons ── */
const InstagramIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
  </svg>
);

const YouTubeIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M23 7s-.3-2-1.2-2.8c-1.1-1.2-2.4-1.2-3-1.3C16.2 2.8 12 2.8 12 2.8s-4.2 0-6.8.1c-.6.1-1.9.1-3 1.3C1.3 5 1 7 1 7S.7 9.1.7 11.3v2c0 2.1.3 4.3.3 4.3s.3 2 1.2 2.8c1.1 1.2 2.6 1.1 3.3 1.2C7.5 21.8 12 21.8 12 21.8s4.2 0 6.8-.2c.6-.1 1.9-.1 3-1.3.9-.8 1.2-2.8 1.2-2.8s.3-2.1.3-4.3v-2C23.3 9.1 23 7 23 7zM9.7 15.5V8.4l6.6 3.6-6.6 3.5z" />
  </svg>
);

const LinkedInIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
    <rect x="2" y="9" width="4" height="12" />
    <circle cx="4" cy="4" r="2" />
  </svg>
);
const FacebookIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
  </svg>
);

/* ── Footer SVG Icons ── */
const YouTubeIconFill = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="#fff">
    <path d="M23 7s-.3-2-1.2-2.8c-1.1-1.2-2.4-1.2-3-1.3C16.2 2.8 12 2.8 12 2.8s-4.2 0-6.8.1c-.6.1-1.9.1-3 1.3C1.3 5 1 7 1 7S.7 9.1.7 11.3v2c0 2.1.3 4.3.3 4.3s.3 2 1.2 2.8c1.1 1.2 2.6 1.1 3.3 1.2C7.5 21.8 12 21.8 12 21.8s4.2 0 6.8-.2c.6-.1 1.9-.1 3-1.3.9-.8 1.2-2.8 1.2-2.8s.3-2.1.3-4.3v-2C23.3 9.1 23 7 23 7zM9.7 15.5V8.4l6.6 3.6-6.6 3.5z" />
  </svg>
);

const FacebookIconFill = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="#fff">
    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
  </svg>
);

const InstagramIconFill = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.5" cy="6.5" r="1" fill="#fff" stroke="none" />
  </svg>
);

const WhatsAppIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
  </svg>
);

const MailIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </svg>
);

const PhoneIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.56 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 9.91a16 16 0 0 0 6.18 6.18l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);


// ─────────────────────────────────────────────────────────────────────────────
export default function Grox24Landing() {
  return (
    <div style={S.page}>

      {/* ══════════════════════════════════════
          HEADER
      ══════════════════════════════════════ */}
      <header style={S.header}>
        <img src={groxLogo} alt="Grox24" style={S.headerLogo} />

        <div style={S.headerRight}>
          <a
            href="https://www.instagram.com/grox24inc/"
            target="_blank"
            rel="noreferrer"
            style={{ ...S.socialLink }}
            onMouseEnter={e => { e.currentTarget.style.background = "#f0027a"; e.currentTarget.style.color = "#fff"; }}
            onMouseLeave={e => { e.currentTarget.style.background = "#f0f5ec"; e.currentTarget.style.color = "#333"; }}
            title="Instagram"
          >
            <InstagramIcon />
          </a>
          <a
            href="https://www.youtube.com/@grox24inc"
            target="_blank"
            rel="noreferrer"
            style={{ ...S.socialLink }}
            onMouseEnter={e => { e.currentTarget.style.background = "#FF0000"; e.currentTarget.style.color = "#fff"; }}
            onMouseLeave={e => { e.currentTarget.style.background = "#f0f5ec"; e.currentTarget.style.color = "#333"; }}
            title="YouTube"
          >
            <YouTubeIcon />
          </a>
          <a
            href="https://www.facebook.com/grox24?ref=1"
            target="_blank"
            rel="noreferrer"
            style={{ ...S.socialLink }}
            onMouseEnter={e => { e.currentTarget.style.background = "#1877F2"; e.currentTarget.style.color = "#fff"; }}
            onMouseLeave={e => { e.currentTarget.style.background = "#f0f5ec"; e.currentTarget.style.color = "#333"; }}
            title="Facebook"
          >
            <FacebookIcon />
          </a>
          <button style={S.downloadBtn}>Download App</button>
        </div>
      </header>

      {/* ══════════════════════════════════════
          SECTION 1 – HERO
      ══════════════════════════════════════ */}
      <section style={S.hero}>
        <div style={S.heroLeft}>
          <h1 style={S.heroH1}>
            <span style={S.heroHighlight}>Fresh</span>
            <br />Groceries.
            <br />Faster Than Ever.
          </h1>

          <p style={{ ...S.heroSub, marginTop: 20, }}>
            Farm-fresh vegetables, fruits, groceries, meat, and essentials
            delivered to your doorstep in minutes.
          </p>
          <div style={S.badgesRow}>
            {/* Google Play */}
            <a
              href="https://play.google.com/store/apps/details?id=com.grox24&pcampaignid=web_share"
              target="_blank"
              rel="noreferrer"
            >
              <img src={googlePlay} alt="Google Play" style={S.storeBadge} />
            </a>

            {/* App Store */}
              <img src={appStore} alt="App Store" style={S.storeBadge} />
          </div>

          <span style={S.servingPill}>Serving Erode City · Expanding Soon</span>
        </div>

        <div style={S.heroRight}>
          <img src={heroCart} alt="Grocery cart" style={S.heroCartImg} />
          <img src={heroPhone} alt="App screenshot" style={S.heroPhoneImg} />
        </div>
      </section>

      {/* ══════════════════════════════════════
          SECTION 2 – CATEGORIES
      ══════════════════════════════════════ */}
      <section id="categories" style={S.catSection}>
        <h2 style={S.catH2}>
          Everything You Need.<br />Delivered Fast.
        </h2>

        <p style={S.catSub}>
          Fresh groceries, daily essentials, and more — all in one place.
        </p>

        <div style={S.catGrid}>
          <div style={S.catCard}
            onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-6px)"; e.currentTarget.style.boxShadow = "12px 18px 0px rgba(0,0,0,0.15)"; }}
            onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0px)"; e.currentTarget.style.boxShadow = "8px 10px 0px rgba(0,0,0,0.15)"; }}
          >
            <img src={catSignature} alt="Signature Fresh" style={S.catImg} />
          </div>

          <div style={S.catCard}
            onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-6px)"; e.currentTarget.style.boxShadow = "12px 18px 0px rgba(0,0,0,0.15)"; }}
            onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0px)"; e.currentTarget.style.boxShadow = "8px 10px 0px rgba(0,0,0,0.15)"; }}
          >
            <img src={catClean} alt="Clean & Fresh" style={S.catImg} />
          </div>

          <div style={S.catCard}
            onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-6px)"; e.currentTarget.style.boxShadow = "12px 18px 0px rgba(0,0,0,0.15)"; }}
            onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0px)"; e.currentTarget.style.boxShadow = "8px 10px 0px rgba(0,0,0,0.15)"; }}
          >
            <img src={catStaples} alt="Daily Staples" style={S.catImg} />
          </div>

          <div style={S.catCard}
            onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-6px)"; e.currentTarget.style.boxShadow = "12px 18px 0px rgba(0,0,0,0.15)"; }}
            onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0px)"; e.currentTarget.style.boxShadow = "8px 10px 0px rgba(0,0,0,0.15)"; }}
          >
            <img src={catDairy} alt="Dairy & Eggs" style={S.catImg} />
          </div>

          <div></div>

          <div style={S.catCard}
            onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-6px)"; e.currentTarget.style.boxShadow = "12px 18px 0px rgba(0,0,0,0.15)"; }}
            onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0px)"; e.currentTarget.style.boxShadow = "8px 10px 0px rgba(0,0,0,0.15)"; }}
          >
            <img src={catMeat} alt="Quality Cuts" style={S.catImg} />
          </div>

          <div style={S.catCard}
            onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-6px)"; e.currentTarget.style.boxShadow = "12px 18px 0px rgba(0,0,0,0.15)"; }}
            onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0px)"; e.currentTarget.style.boxShadow = "8px 10px 0px rgba(0,0,0,0.15)"; }}
          >
            <img src={catSnacks} alt="Quick Bites" style={S.catImg} />
          </div>

          <div style={S.catCard}
            onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-6px)"; e.currentTarget.style.boxShadow = "12px 18px 0px rgba(0,0,0,0.15)"; }}
            onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0px)"; e.currentTarget.style.boxShadow = "8px 10px 0px rgba(0,0,0,0.15)"; }}
          >
            <img src={catCleaning} alt="Everyday Needs" style={S.catImg} />
          </div>

          <div style={S.catCard}
            onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-6px)"; e.currentTarget.style.boxShadow = "12px 18px 0px rgba(0,0,0,0.15)"; }}
            onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0px)"; e.currentTarget.style.boxShadow = "8px 10px 0px rgba(0,0,0,0.15)"; }}
          >
            <img src={catHygiene} alt="Daily Hygiene" style={S.catImg} />
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <div style={S.browseCard}>
              <p style={S.browsePre}>Browse</p>
              <p style={S.browseNum}>1000+</p>
              <p style={S.browseLabel}>Products</p>
            </div>
            <button
              style={S.shopNowBtn}
              onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-4px)"; e.currentTarget.style.boxShadow = "10px 14px 0px rgba(0,0,0,0.35)"; }}
              onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0px)"; e.currentTarget.style.boxShadow = "6px 8px 0px rgba(0,0,0,0.25)"; }}
            >
              SHOP NOW
            </button>
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════
          SECTION 3 – SIGNATURE FRESH
      ══════════════════════════════════════ */}
      <section id="signature" style={S.sigSection}>
        <div style={S.sigTop}>
          <div style={S.sigLeft}>
            <h2 style={S.sigH2}>
              <strong>SIGNATURE</strong>{" "}
              <span style={S.sigH2Light}>FRESH.</span>
            </h2>
            <h3 style={S.sigH3}>Our Standard of Clean.</h3>
            <p style={S.sigBody}>
              Signature Fresh is our exclusive freshness process for vegetables
              and fruits. Each item is carefully Signature-washed, cleaned, and
              handled hygienically before it reaches your kitchen.
            </p>
          </div>
          <img src={sigBadge} alt="Signature Fresh badge" style={S.sigBadgeImg} />
        </div>
        <div style={S.sigCards}>
          <div style={{ ...S.sigCard, ...S.card1 }}>
            <p style={S.sigCardTitle}>Signature Wash</p>
            <p style={S.sigCardText}>
              An advanced multistage cleaning process to remove dirt and surface chemical residues.
            </p>
          </div>
          <div style={{ ...S.sigCard, ...S.card2 }}>
            <p style={S.sigCardTitle}>Freshly Packed</p>
            <p style={S.sigCardText}>
              Packed only after cleaning to preserve freshness.
            </p>
          </div>
          <div style={{ ...S.sigCard, ...S.card3 }}>
            <p style={S.sigCardTitle}>Hygienically Handled</p>
            <p style={S.sigCardText}>
              Carefully processed in clean environments with strict quality checks.
            </p>
          </div>
          <div style={{ ...S.sigCard, ...S.card4 }}>
            <p style={S.sigCardTitle}>Safer for Your Family</p>
            <p style={S.sigCardText}>
              Cleaner produce, ready for your kitchen.
            </p>
          </div>
        </div>
        <img src={sigSplash} alt="Vegetables splash" style={S.sigSplashImg} />
      </section>

      {/* ══════════════════════════════════════
          SECTION 4 – WHY TRUST GROX24
      ══════════════════════════════════════ */}
      <section id="trust" style={S.trustSection}>
        <h2 style={S.trustH2}>
          WHY DO FAMILIES TRUST <span style={S.trustH2Bold}>GROX24?</span>
        </h2>

        <div style={S.trustGrid}>
          <div style={S.trustCard}>
            <div style={S.iconCircle}>
              <img src={iconSigFresh} alt="Signature Fresh" style={S.trustIcon} />
            </div>
            <p style={S.trustText}>
              Our exclusive Signature Fresh™ Clean System ensures safer, cleaner produce for your family.
            </p>
          </div>

          <div style={S.trustCard}>
            <div style={S.iconCircle}>
              <img src={iconDelivery} alt="Fast delivery" style={S.trustIcon} />
            </div>
            <p style={S.trustText}>
              Fast and reliable delivery — fresh groceries at your doorstep, right on time.
            </p>
          </div>

          <div style={S.trustCard}>
            <div style={S.iconCircle}>
              <img src={iconVariety} alt="Variety" style={S.trustIcon} />
            </div>
            <p style={S.trustText}>
              Fresh produce, daily essentials, and more — all in one app.
            </p>
          </div>

          <div style={S.trustCard}>
            <div style={S.iconCircle}>
              <img src={iconTrusted} alt="Most Trusted Brands" style={S.trustIcon} />
            </div>
            <p style={S.trustText}>
              Designed to serve families with quality, care, and consistency.
            </p>
          </div>
        </div>

        <div style={S.trustBanner}>
          Freshness you can see. Quality you can trust.
        </div>
      </section>

      {/* ══════════════════════════════════════
          SECTION 5 – FLAVORS
      ══════════════════════════════════════ */}
      <section id="flavors" style={S.flavorsSection}>
        <div style={S.flavorsLeft}>
          <img src={flavorsFood} alt="Nutritious bowl" style={S.flavorsImg} />
          <div style={S.flavorsOverlay}>
            <img src={flavorsLogo} alt="Flavors" style={S.flavorsLogoImg} />
            <p style={S.flavorsTagline}>Smart Nutrition, Built In</p>
            <p style={S.flavorsBody}>
              Flavors is your built-in nutrition companion — helping families
              discover balanced recipes, plan healthier weekly menus, and
              automatically adjust ingredient quantities based on family size.
            </p>
          </div>
        </div>

        <div style={S.flavorsRight}>
          <div style={{ ...S.flavorsFeature, ...S.flavorsFeatureTeal }}>
            <p style={S.fFTitle}>Balanced Meal Discovery</p>
            <p style={S.fFText}>Curated recipes focused on everyday nutrition and smart eating habits.</p>
          </div>
          <div style={{ ...S.flavorsFeature, ...S.flavorsFeatureGreen }}>
            <p style={S.fFTitle}>Personalized Portions</p>
            <p style={S.fFText}>Select your family size and ingredient quantities adjust automatically to match your needs.</p>
          </div>
          <div style={{ ...S.flavorsFeature, ...S.flavorsFeatureSkyTeal }}>
            <p style={S.fFTitle}>Seamless Grocery Sync</p>
            <p style={S.fFText}>Add complete recipe ingredients directly to your Grox24 cart in one tap.</p>
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════
          SECTION 6 – CTA / DOWNLOAD
      ══════════════════════════════════════ */}
      <section style={S.ctaSection}>
        <div style={S.ctaLeft}>
          <h2 style={S.ctaH2}>Fresh Groceries. Smart Planning. One App.</h2>
          <p style={S.ctaSub}>
            From fresh groceries to smart meal planning with Flavors, Grox24
            brings everything together in one seamless experience.
          </p>

          <ul style={S.ctaList}>
            {[
              "Fresh groceries delivered fast",
              "Signature Fresh™ clean system",
              "Built-in Smart Nutrition with Flavors",
              "Easy ordering & secure checkout",
            ].map((item) => (
              <li key={item} style={S.ctaItem}>
                <span style={S.ctaCheck}>✓</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>

          <button style={S.ctaBtn}>Download Grox24 Now</button>
          <div style={S.badgesRow}>
            {/* Google Play */}
            <a
              href="https://play.google.com/store/apps/details?id=com.grox24&pcampaignid=web_share"
              target="_blank"
              rel="noreferrer"
            >
              <img src={googlePlay} alt="Google Play" style={S.storeBadge} />
            </a>
              <img src={appStore} alt="App Store" style={S.storeBadge} />
          </div>
        </div>

        <div style={S.ctaRight}>
          <img src={ctaPhone1} alt="App screen 1" style={S.ctaPhone} />
          <img src={ctaPhone2} alt="App screen 2" style={S.ctaPhoneCenter} />
          <img src={ctaPhone3} alt="App screen 3" style={S.ctaPhone} />
        </div>
      </section>

      {/* ══════════════════════════════════════
          FOOTER
      ══════════════════════════════════════ */}
      <footer style={S.footer}>
        <div style={S.footerGrid}>
          <div style={S.footerBrand}>
            <img src={groxLogo} alt="Grox24" style={S.footerLogoImg} />
            <p style={S.footerTagline}>Fresh groceries. Smart planning. One app.</p>
            <p style={S.footerDesc}>
              Grox24 is committed to delivering fresh, hygienically processed groceries and smart nutrition planning solutions to modern families.
            </p>
            <div style={S.footerSocialRow}>
              {/* Instagram */}
              <a
                href="https://www.instagram.com/grox24inc/"
                target="_blank"
                rel="noreferrer"
                style={{
                  ...S.footerSocialIcon,
                  background:
                    "radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%, #d6249f 60%, #285AEB 90%)"
                }}
              >
                <InstagramIconFill />
              </a>
              {/* YouTube */}
              <a
                href="https://www.youtube.com/@grox24inc"
                target="_blank"
                rel="noreferrer"
                style={{ ...S.footerSocialIcon, background: "#FF0000" }}
              >
                <YouTubeIconFill />
              </a>

              {/* Facebook */}
              <a
                href="https://www.facebook.com/grox24?ref=1"
                target="_blank"
                rel="noreferrer"
                style={{ ...S.footerSocialIcon, background: "#1877F2" }}
              >
                <FacebookIconFill />
              </a>



            </div>
          </div>

          {/* ── Quick Links ── */}
          <div>
            <h4 style={S.footerColTitle}>Quick Links</h4>
            <ul style={S.footerLinks}>
              {[
                { label: "Home", link: "#top" },
                { label: "Categories", link: "#categories" },
                { label: "Signature Fresh", link: "#signature" },
                { label: "Flavors", link: "#flavors" },
                { label: "Why Grox24", link: "#trust" },
                { label: "Contact", link: "#footer" },
              ].map(item => (
                <li key={item.label}>
                  <a
                    href={item.link}
                    style={S.footerLink}
                    onMouseEnter={e => e.currentTarget.style.color = "#46A084"}
                    onMouseLeave={e => e.currentTarget.style.color = "#aaa"}
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 style={S.footerColTitle}>Support</h4>
            <ul style={S.footerLinks}>
              {[
                { label: "Disclaimer", path: "/disclaimer" },
                { label: "Shipping and Delivery", path: "/delivery" },
                { label: "Refund", path: "/refund" },
                { label: "Terms & Conditions", path: "/terms" },
                { label: "Privacy Policy", path: "/privacy" }
              ].map(item => (
                <li key={item.label}>
                  <Link
                    to={item.path}
                    style={S.footerLink}
                    onMouseEnter={e => e.currentTarget.style.color = "#46A084"}
                    onMouseLeave={e => e.currentTarget.style.color = "#aaa"}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* ── Contact Info ── */}
          <div>
            <h4 style={S.footerColTitle}>Contact Info</h4>
            <p style={S.footerContactLine}>Email: support@grox24.com</p>
            <p style={S.footerContactLine}>Phone: +91 9787 022 922</p>
            <div style={S.footerContactIcons}>
              {/* WhatsApp */}
              <a
                href="https://wa.me/919787022922"
                target="_blank"
                rel="noreferrer"
                style={S.footerContactIconCircle}
                onMouseEnter={e => { e.currentTarget.style.background = "#46A084"; e.currentTarget.style.color = "#fff"; }}
                onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "#46A084"; }}
                title="WhatsApp"
              >
                <WhatsAppIcon />
              </a>

              {/* Mail */}
              <a
                href="mailto:support@grox24.com"
                style={S.footerContactIconCircle}
                onMouseEnter={e => { e.currentTarget.style.background = "#46A084"; e.currentTarget.style.color = "#fff"; }}
                onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "#46A084"; }}
                title="Email"
              >
                <MailIcon />
              </a>

              {/* Phone */}
              <a
                href="tel:+919787022922"
                style={S.footerContactIconCircle}
                onMouseEnter={e => { e.currentTarget.style.background = "#46A084"; e.currentTarget.style.color = "#fff"; }}
                onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "#46A084"; }}
                title="Phone"
              >
                <PhoneIcon />
              </a>

            </div>
          </div>

        </div>

        {/* ── Copyright Bar ── */}
        <div style={S.footerBottom}>
          © 2026 Grox24 a Towego Company. All rights reserved.
        </div>
      </footer>

    </div>
  );
}